import { render, staticRenderFns } from "./PedidoCompra.vue?vue&type=template&id=ffd91dd2&scoped=true"
import script from "./PedidoCompra.vue?vue&type=script&lang=js"
export * from "./PedidoCompra.vue?vue&type=script&lang=js"
import style0 from "./PedidoCompra.vue?vue&type=style&index=0&id=ffd91dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd91dd2",
  null
  
)

export default component.exports